export const SET_BAGGAGE_FUEL_ECONOMY = 'SET_BAGGAGE_FUEL_ECONOMY';
